import { onApiError } from "../error";
import { get, put } from "./client";

/**
 * @param {string} imei
 * @returns {Promise<Fencealarm2>}
 */
async function getFenceAlarm2(imei) {
	const res = await get(`/fencealarm2s/${imei}`);

	if (!res.ok) throw await onApiError(res);
	return res.json();
}

/**
 * @typedef {Object} VoltageDataPoint
 * @property {string} Imei
 * @property {number} Voltage
 * @property {string} Timestamp
 */

/**
 * @param {string} imei
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<VoltageDataPoint[]|Blob>}
 */
async function getFencealarm2Voltage(imei, args) {
	const queryString = [
		args?.from ? `from=${args.from}` : "",
		args?.to ? `to=${args.to}` : "",
		args?.format ? `format=${args.format}` : "",
	];

	let path = `/fencealarm2s/${imei}/voltage`;
	if (queryString.length > 0) {
		path += `?${queryString}`;
	}

	const res = await get(path);
	if (!res.ok) throw await onApiError(res);
	if (args?.format !== "json") return res.blob();
	return res.json();
}

/**
 * @param {string} imei
 * @param {FlashFencealarm2Params} args
 */
async function putFencealarm2Fota(imei, args) {
	const res = await put(`/fencealarm2s/${imei}/fota`, {
		body: JSON.stringify(args),
	});

	if (!res.ok) throw await onApiError(res);
}

export { getFenceAlarm2, getFencealarm2Voltage, putFencealarm2Fota };
